export default __webpack_public_path__ + "/dist/images/logo5.54cd1bc07b87970426542908d5ab2009.jpg";